import { defineStore } from 'pinia';
import type { Student } from '@/api';

export const useApplyStore = defineStore('apply', () => {
    const applyingStudent = shallowRef<Student>();
    return {
        applyingStudent,
    };
});
